import * as React from "react";
const SvgRecrutliveFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14 9a2 2 0 0 1 1.2.4l5.334 4a2 2 0 0 1 0 3.2l-5.334 4A2 2 0 0 1 12 19v-8a2 2 0 0 1 2-2M5 3a2 2 0 0 1 1.2.4l5.334 4a2 2 0 0 1 0 3.2l-5.334 4A2 2 0 0 1 3 13V5a2 2 0 0 1 2-2", clipRule: "evenodd" }));
export default SvgRecrutliveFill;
